// Helper function to check if click is outside dropdown
export function isClickOutsideDropdown(
  event: MouseEvent,
  triggerKey: string,
  typeDropdownRefs: React.MutableRefObject<{ [key: string]: HTMLElement | null }>
): boolean {
  const triggerElement = typeDropdownRefs.current[triggerKey]
  return !!(triggerElement && !triggerElement.contains(event.target as Node))
}

// Helper function to create click outside handler
export function createClickOutsideHandler(
  companyId: string,
  roleId: string,
  typeDropdownRefs: React.MutableRefObject<{ [key: string]: HTMLElement | null }>,
  handleCloseTypeDropdown: () => void
) {
  return (event: MouseEvent) => {
    const triggerKey = `${companyId}-${roleId}-type`
    if (isClickOutsideDropdown(event, triggerKey, typeDropdownRefs)) {
      handleCloseTypeDropdown()
    }
  }
}

// Helper function to setup dropdown listeners
export function setupDropdownListeners(
  companyId: string,
  roleId: string,
  typeDropdownRefs: React.MutableRefObject<{ [key: string]: HTMLElement | null }>,
  handleCloseTypeDropdown: () => void
) {
  const handleClickOutside = createClickOutsideHandler(companyId, roleId, typeDropdownRefs, handleCloseTypeDropdown)
  const handleScroll = () => handleCloseTypeDropdown()

  document.addEventListener('mousedown', handleClickOutside)
  window.addEventListener('scroll', handleScroll, true)

  return () => {
    document.removeEventListener('mousedown', handleClickOutside)
    window.removeEventListener('scroll', handleScroll, true)
  }
}
